<nb-card>
  <nb-card-header>
    <div class="logo-container">
      <a href="#"><img alt="log" src="../../../../assets/images/logo-alternative.svg" href="#" /></a>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert" status="error">
      <p class="alert-title"><b>Corrija seus dados!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>

    <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert"
      status="success">
      <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
      </ul>
    </nb-alert>

    <form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">
      <div class="form-control-group">
        <label class="label" for="input-email">Email</label>
        <input nbInput fullWidth [(ngModel)]="user.email" #email="ngModel" name="email" id="input-email"
          pattern=".+@.+\..+" placeholder="Email address" autofocus
          [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
          [required]="getConfigValue('forms.validation.email.required')"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null">
        <ng-container *ngIf="email.invalid && email.touched">
          <p class="caption status-danger" *ngIf="email.errors?.required">
            Este campo é obrigatório!
          </p>
          <p class="caption status-danger" *ngIf="email.errors?.pattern">
            É necessário um e-mail válido!
          </p>
        </ng-container>
      </div>

      <div class="form-control-group">
        <span class="label-with-link">
          <label class="label" for="input-password">Senha</label>
          <a class="forgot-password caption-2" routerLink="../request-password">Esqueceu a senha?</a>
        </span>
        <input nbInput fullWidth [(ngModel)]="user.password" #password="ngModel" name="password" type="password"
          id="input-password" placeholder="Senha"
          [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
          [required]="getConfigValue('forms.validation.password.required')"
          [minlength]="getConfigValue('forms.validation.password.minLength')"
          [maxlength]="getConfigValue('forms.validation.password.maxLength')"
          [attr.aria-invalid]="password.invalid && password.touched ? true : null">
        <ng-container *ngIf="password.invalid && password.touched ">
          <p class="caption status-danger" *ngIf="password.errors?.required">
            Não esqueça sua senha!
          </p>
          <p class="caption status-danger" *ngIf="(password.errors?.minlength || password.errors?.maxlength)">
            A senha deve conter
            de {{ getConfigValue('forms.validation.password.minLength') }}
            até {{ getConfigValue('forms.validation.password.maxLength') }}
            caracteres.
          </p>
        </ng-container>
      </div>

      <button fullWidth nbButton status="primary" size="large" [disabled]="submitted || !form.valid"
        [nbSpinner]="loading" nbSpinnerStatus="primary" nbSpinnerSize="large" nbSpinnerMessage="">
        Acessar
      </button>
    </form>
    <section *ngIf="socialLinks && socialLinks.length > 0" class="links" aria-label="Social sign in">
      Ou acesse com:
      <div class="socials">
        <ng-container *ngFor="let socialLink of socialLinks">
          <a *ngIf="socialLink.link" [routerLink]="socialLink.link" [attr.target]="socialLink.target"
            [attr.class]="socialLink.icon" [class.with-icon]="socialLink.icon">{{ socialLink.title }}</a>
          <a *ngIf="socialLink.url" [attr.href]="socialLink.url" [attr.target]="socialLink.target"
            [attr.class]="socialLink.icon" [class.with-icon]="socialLink.icon">{{ socialLink.title }}</a>
        </ng-container>
      </div>
    </section>
  </nb-card-body>
  <nb-card-footer>
    <section class="another-action" aria-label="Register">
      Ainda não é Discoverpay? <a class="text-link" routerLink="../register">Seja Discoverpay!</a>
    </section>
  </nb-card-footer>
</nb-card>